function _hashed_password(r){var t=CryptoJS.lib.WordArray.random(256),o=CryptoJS.lib.WordArray.random(16),y=CryptoJS.lib.WordArray.random(16);y=CryptoJS.enc.Hex.stringify(y);var e=CryptoJS.PBKDF2(y,t,{hasher:CryptoJS.algo.SHA512,keySize:8,iterations:999}),i=CryptoJS.AES.encrypt(r,e,{iv:o});return CryptoJS.enc.Base64.stringify(i.ciphertext)+"|"+(t=CryptoJS.enc.Hex.stringify(t))+"|"+(o=CryptoJS.enc.Hex.stringify(o))+"|"+y}
function cleanedInput(phoneVal){
  return ('' + phoneVal).replace(/\D/g, '');
}
var urlParams = new URLSearchParams(window.location.search);
var $enrollmentForm = $('form#create_customer'),
    $loginForm = $('form#customer_login'),
    $resetPasswordForm = $('#ResetPasswordForm form'),
    $phone = $('#phone'),
    formData = {
      'target_url': "//enfashop.com.mx/account",
      'host_url': "//enfashop.com.mx/",
      'langcode': 'es',
      'host_tag': 'Shop_ES'
    };
$phone.on('keyup keypress change', function(e) { 
  // Check only number
  const digitsInString = /[0-9]+/g; 
  if (!e.key.match(digitsInString)) return false
  const phoneValue = $(this).val();
  // Format Phone No
  let final;
  const phoneNumber = cleanedInput(phoneValue);
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 3){
    final =  phoneNumber;
  }
  else if (phoneNumberLength < 7) {
    final =  `(${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2)}`;
  }
  else { 
    final = `(${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2, 6)}-${phoneNumber.slice(6, 10)}`;
  }
  $(this).val(final);        
});
$enrollmentForm.on('submit', function(e) {
  e.preventDefault();
  var longtime = new Date(Date.now());
  longtime.setMonth(longtime.getMonth() + 12);
  document.cookie = 'DialogPromo=' + window.location.pathname + '; expires=' + longtime + '; path=/';
  removeFormErrors($(this));
  const $fName = $(this).find('#fname'),
      $lName = $(this).find('#lname'),
      $email = $(this).find('#email'),
      $birthdate = $(this).find('#birthdate'),
      $phone = $(this).find('#phone'),
      $pass = $(this).find('#password');
  var validationCriteria = [{
    'field': $fName,
    'error': 'Por favor ingresa un nombre válido',
    'regex': '^[a-zA-ZáéíñóúüÁÉÍÑÓÚÜ][a-zA-ZáéíñóúüÁÉÍÑÓÚÜ ]*$'
  }, {
    'field': $lName,
    'error': 'Por favor ingresa un apellido válido',
    'regex': '^[a-zA-ZáéíñóúüÁÉÍÑÓÚÜ][a-zA-ZáéíñóúüÁÉÍÑÓÚÜ ]*$' //'^[a-zA-Z][a-zA-Z ]*$'  //'^[a-zA-Z]*$'
  }, {
    'field': $email,
    'error': 'Por favor ingresa un Correo Electrónico válido',
    'regex': '^([0-9a-zA-Z]+[-._+&])*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$'
  }, {
    'field': $pass,
    'error': 'Por favor ingresa un Password válido',
    'regex': '^(?=.*[a-z])(?=.*[A-Z])((?=.*[0-9])|(?=.*[!@#\$%\^&\*]))(?=.{8,})'
  }];
  var isValid = validateFields(validationCriteria);
  const phoneVal = $phone.val();
  if($.trim(phoneVal) !== ''){
    const regex = /^\d{10}$/;
    const $formGroup = $phone.closest('.form-group');
    const error = "Tu teléfono no es válido, revisa que contenga 10 números";
    const cleaned_phone_input = cleanedInput(phoneVal);
    if (!cleaned_phone_input.match(regex)){
      isValid = false; 
      $formGroup.find('.error-msg').remove();
      $formGroup.addClass('has-error').append(`<div class="error-msg">${error}</div>`);
    }
  }
  if (isValid) {
    var url = "//www.enfabebe.com.mx/enfa-auth-api/v1/user-enrollment/retrieve.json";
    formData['accept_marketing'] = ($(this).find("#CustomerFormoptin").length && $(this).find("#CustomerFormoptin").prop('checked')) ? true : false;
    formData['key'] = _hashed_password($pass.val());
    formData['crmpath'] = 'enrollment';
    $.each($(this).serializeArray(), function() {
      formData[this.name] = this.value;
    });
    formData['phone'] = cleanedInput(phoneVal);
    $.ajax(buildDEPAjax(url, formData)).done(function(response) {
      doMultipassOrShowError($enrollmentForm, response);
    }).fail(function(response) {
      doMultipassOrShowError($enrollmentForm, 'apifail');
    });
  }
});

$loginForm.on('submit', function(e) {
  e.preventDefault();
  removeFormErrors($(this));
  var $email = $(this).find('#CustomerEmail'),
      $pass = $(this).find('#CustomerPassword');
  var validationCriteria = [{
    'field': $email,
    'error': 'Por favor ingresa un Correo Electrónico válido',
    'regex': '^([0-9a-zA-Z]+[-._+&])*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$'
  }, {
    'field': $pass,
    'error': 'Por favor ingresa un Password válido',
    'regex': ''//^(?=.*[a-z])(?=.*[A-Z])((?=.*[0-9])|(?=.*[!@#\$%\^&\*]))(?=.{8,})
  }];
  var isValid = validateFields(validationCriteria);
  if (isValid) {
    var url = "//www.enfabebe.com.mx/enfa-auth-api/v1/user-login/retrieve.json";
    formData['usermail'] = $email.val();
    formData['key'] = _hashed_password($pass.val());
    if(urlParams.get('checkout_url')){
      formData['target_url']=urlParams.get('checkout_url');
    }
    $.each($(this).serializeArray(), function() {
      formData[this.name] = this.value;
    });
    $.ajax(buildDEPAjax(url, formData)).done(function(response) {
      doMultipassOrShowError($loginForm, response);
    }).fail(function(response) {
      doMultipassOrShowError($loginForm, 'apifail');
    });
  }
});

$resetPasswordForm.on('submit', function(e) {
  e.preventDefault();
  removeFormErrors($(this));
  var $pass = $(this).find('#ResetPassword'),
      $passRepeat = $(this).find('#PasswordConfirmation');
  var validationCriteria = [{
    'field': $pass,
    'error': 'Tu contraseña no es lo suficientemente segura',
    'regex': '^(?=.*[a-z])(?=.*[A-Z])((?=.*[0-9])|(?=.*[!@#\$%\^&\*]))(?=.{8,})'
  }];
  var isValid = validateFields(validationCriteria);
  if (isValid) {
    if ($pass.val() != $passRepeat.val()) {
      var $formGroup = $passRepeat.closest('.form-group');
      $formGroup.find('.error-msg').remove();
      $formGroup.addClass('has-error').append('<div class="error-msg">Password and Confirm Password should match.</div>');
      return;
    }
    var url = "//www.enfabebe.com.mx/enfa-auth-api/v1/user-shop-reset-password/retrieve.json",
        shop_url = window.location.href.split("/");
    formData['key'] = _hashed_password($pass.val());
    formData['userkey'] = shop_url[shop_url.length - 2];
    $.ajax(buildDEPAjax(url, formData)).done(function(response) {
      doMultipassOrShowError($resetPasswordForm, response);
    }).fail(function(response) {
      doMultipassOrShowError($resetPasswordForm, 'apifail');
    });
  }
});

// Show Info on RecoverPassword.
var reset_status = (document.cookie.match(/^(?:.*;)?\s*reset_status\s*=\s*([^;]+)(?:.*)?$/)||[null,null])[1];
if (reset_status && reset_status == 'success') {
  document.cookie = "reset_status=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  $loginForm.find('.error-message').removeClass('hidden');
  $loginForm.find('.error-message').html('Further instructions have been sent to your email.').addClass('success');
}

/* Common methods. */
function validateFields(validationCriteria) {
  var isValid = true;
  for (let validationCriterion of validationCriteria) {
    var $field = validationCriterion.field,
        $val = $field.val(),
        $regex = validationCriterion.regex;
    if (!($val && $val.match(new RegExp($regex)))) {
      isValid = false;
      var $formGroup = $field.closest('.form-group');
      $formGroup.find('.error-msg').remove();
      $formGroup.addClass('has-error').append('<div class="error-msg">' + validationCriterion.error + '</div>');
    }
  }
  return isValid;
}

function buildDEPAjax(url, formData) {
  var token = btoa(window.depClient + ':' + window.depKey);
  return {
    type: 'POST',
    url: url,
    crossDomain: true,
    data: {
      data: _hashed_password(JSON.stringify(formData))
    },
    beforeSend: function(xhr) {
      $(".loader, .throbber-overlay").show();
      xhr.setRequestHeader("Authorization", "Basic " + token);
    },
    dataType: 'json'
  };
}

function doMultipassOrShowError($formElem, response) {
  if (typeof response === 'string' && response == 'apifail') {
    $(".loader, .throbber-overlay").hide();
    $formElem.find('.error-message').removeClass('hidden success').html('Something went wrong! Please try again later.');
    return false;
  }
  if (typeof response !== 'undefined' && typeof response.form_error !== 'undefined') {
    $formElem.find('.error-message').removeClass('hidden success').html(response.form_error);
    $(".loader, .throbber-overlay").hide();
    if ($formElem.find('.error-message').find('.email_error_exists').length) {
      $formElem.find('input[type=email]').closest('.form-group').addClass("has-error");
    }
  } else if (typeof response !== 'undefined' && typeof response.multipass_url !== 'undefined') {
    removeFormErrors($formElem);
    localStorage.setItem('snipp_member', response.snipp_member);
    const non_snipp_logged_in = (response.snipp_member !== true);
    localStorage.setItem('non_snipp_logged_in', non_snipp_logged_in);
    if (non_snipp_logged_in && response.token) {
      const tokens = CryptoJS.AES.encrypt(JSON.stringify({
        "auth_bearer_token": response.token.access_token,
        "csrf_token": response.token.csrf_token
      }), "JOPx3YOnYmcLvN5lqI4DEbpENdK5158QWm8ojDZ381mIvIls4g9XNLpLbnFYKx58");
      localStorage.setItem('snipp_register', tokens);
    }
    window.location = response.dep_sso_url;
  }
}

function removeFormErrors($formElem) {
  $formElem.find('.error-message').addClass('hidden');
  $formElem.find('.has-error').removeClass('has-error');
  $formElem.find('.error-msg').remove();
}
